module.exports = __webpack_public_path__ + "static/media/Cover.2917a2bd.jpg";